import { BooleanDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";

export const expressionStoryData = new DataDefinition();
expressionStoryData.fields.push(new BooleanDataDefinition("isEmployee"));
expressionStoryData.fields.push(new NumberDataDefinition("income"));
expressionStoryData.fields.push(new NumberDataDefinition("age"));
expressionStoryData.fields.push(new BooleanDataDefinition("isContractor"));
let personfield = new ObjectDataDefinition("person");
personfield.fields.push(new StringDataDefinition("name"));
expressionStoryData.fields.push(personfield);
